module.exports = __webpack_public_path__ + "6b328732.woff2";